import React from 'react'
import { WemoloToggle, WemoloTypography } from '../../../components/Wemolo'
import styles from './LabelToggleRow.module.css'

interface LabeledToggleRowProps {
    label: string
    caption?: string
    checked: boolean
    onToggle: (newChecked: boolean) => void
    icon?: React.ReactNode
}

export const LabeledToggleRow: React.FC<LabeledToggleRowProps> = ({ label, checked, onToggle, icon }) => {
    return (
        <div className={styles.row}>
            <div className={styles.labelGroup}>
                {icon && <div className={styles.iconWrapper}>{icon}</div>}
                <WemoloTypography variant="label-medium" tag="span">
                    {label}
                </WemoloTypography>
            </div>

            <WemoloToggle size="small" checked={checked} onChange={(e) => onToggle(e.target.checked)} />
        </div>
    )
}
